export var pt = {
  DATE_PICKER_PLACEHOLDER: '00/00/0000 - 00/00/0000',
  DATE_PICKER_LAST_TAB: 'Último',
  DATE_PICKER_SINGLE_TAB: 'Específico',
  DATE_PICKER_RANGE_TAB: 'Intervalo',
  DATE_PICKER_LAST_LABEL: 'Últimos {{count}} dias',
  DATE_PICKER_LAST_OPTION_LABEL: '{{count}} dias'
};